<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'community.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="re-hub-scroll community-page">
  <div class="community-shell">
    <section class="community-hero">
      <span class="community-hero__badge re-badge">{{ 'community.heroBadge' | translate }}</span>
      <h1 class="community-hero__title">{{ 'community.title' | translate }}</h1>
      <div class="community-hero__divider" aria-hidden="true"></div>
      <p class="community-hero__lead">{{ 'community.heroLead' | translate }}</p>
    </section>

    <section class="community-nav">
      <p class="community-section-label re-section-label">{{ 'community.sectionExplore' | translate }}</p>
      <ion-card class="community-nav-card re-action-card" [button]="true" routerLink="character-templates">
        <ion-card-content>
          <div class="community-nav-card__icon re-action-card__icon" aria-hidden="true">
            <ion-icon name="grid-outline"></ion-icon>
          </div>
          <p class="community-nav-card__title re-action-card__title">
            {{ 'community.templatesTitle' | translate }}
          </p>
          <p class="community-nav-card__desc re-action-card__description">
            {{ 'community.templatesSubtitle' | translate }}
          </p>
        </ion-card-content>
      </ion-card>
    </section>
  </div>
</ion-content>
